module.exports = __webpack_public_path__ + "static/img/commodity66ab3ec.png";